package com.appsyde.shared.modules.ai.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class AiGenerateResponseV2(
    val text: String
)
